import { trustBadges } from '@/mocks/homeContent';

export default function TrustBadges() {
  return (
    <div className="border-t border-b border-background-200 bg-background-50">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 md:px-10 lg:px-12 xl:px-16 py-6 md:py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {trustBadges.map((badge) => (
            <div key={badge.title} className="flex items-start gap-3">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-accent-700 text-base md:text-lg">
                  <i className={badge.icon} />
                </span>
              </div>
              <div>
                <p className="text-sm md:text-[15px] font-bold text-foreground-800 leading-snug">
                  {badge.title}
                </p>
                <p className="text-xs text-foreground-500 leading-snug mt-0.5">
                  {badge.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}